import React, {useMemo} from 'react';
import {useDropzone} from 'react-dropzone';
import CloudUpload from '@mui/icons-material/CloudUpload';
import { Typography } from '@mui/material';

 const baseStyle =  {
  flex: 1,
  display: 'flex',
  flexDirection: 'column' as const,
  justifyContent: 'center',
  alignItems: 'center',
  padding: '75px 20px 20px 20px',
  minHeight: 200,
  borderWidth: 2,
  borderRadius: 5,
  borderColor: '#CCCCCC',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#212529',
  outline: 'none',
  transition: 'border .24s ease-in-out'
};

const focusedStyle = {
  borderColor: '#2196f3'
};

const acceptStyle = {
  borderColor: '#00e676'
};

const rejectStyle = {
  borderColor: '#ff1744'
};

/** Default accept list for general uploads; override via `accept` prop (e.g. PDF-only extraction). */
const STYLED_DROPZONE_DEFAULT_ACCEPT = {
  'image/*': [],
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
} as const;

export function StyledDropzone(props: any) {
  const accept = props.accept ?? STYLED_DROPZONE_DEFAULT_ACCEPT;
  const {
    getRootProps,
    getInputProps,
    acceptedFiles,
    isFocused,
    isDragAccept,
    isDragReject
  } = useDropzone({
    accept,
    multiple: true,
    // When false, browse uses <input type="file"> so the `accept` attribute filters the OS dialog.
    // File System Access API (default true) can show a broader file list on some browsers/OSes.
    useFsAccessApi: props.useFsAccessApi ?? true,
    onDrop: (files: File[]) => {
      if (props.onFileDrop) {
        props.onFileDrop(files);
      }
    }
  });

  const style = useMemo(() => ({
    ...baseStyle,
    ...(isFocused ? focusedStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {})
  }), [
    isFocused,
    isDragAccept,
    isDragReject
  ]);

  // const files = acceptedFiles.map((file, index) => (
  //   <li key={index} style={{ fontSize: "14px", marginTop: "5px" }}>
  //     {file.name} - {(file.size / 1024).toFixed(2)} KB
  //   </li>
  // ));

  return (
    <div {...getRootProps({style})}>
      <input
        {...getInputProps(
          props.inputAccept
            ? { accept: props.inputAccept }
            : {}
        )}
        name="files"
      />
      <CloudUpload sx={{ fontSize: 48, color: '#02A4E3', mb: 2 }} />
      <Typography variant="h6" sx={{ color: '#666', mb: 1 }}>
          Select File or Drag and Drop
      </Typography>
      <Typography variant="body2" sx={{ color: '#999' }}>
          Click to browse files or drag and drop multiple files here
      </Typography>
      {/* {acceptedFiles.length > 0 && (
        <aside style={{ marginTop: "10px" }}>
          <ul style={{ listStyle: "none", padding: 0 }}>
            {files}
          </ul>
        </aside>
      )} */}
    </div>
  );
}